module.exports = __webpack_public_path__ + "img/search-icon.32d3ddd7.svg";